import React, { createContext, useContext, useState } from "react";
import { FullUserDTO } from "../types/User";
import Cookies from "js-cookie";
import { Billing } from "../types/Billing";

interface AuthContextInterface {
  loggedUser?: FullUserDTO;
  billingData?: Billing;
  token?: string;
  isBillingDataReady?: boolean;
  setLoggedUser: React.Dispatch<React.SetStateAction<FullUserDTO | undefined>>;
  setBillingData: React.Dispatch<React.SetStateAction<Billing | undefined>>;
  setIsBillingDataReady: React.Dispatch<React.SetStateAction<boolean | false>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  newNotifications?: number;
  setNewNotifications: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const AuthContext = createContext<AuthContextInterface>(
  {} as AuthContextInterface
);

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  const cookie = Cookies.get(window.__env.AUTH_TOKEN_NAME || "get-move-token");
  const [isBillingDataReady, setIsBillingDataReady] = useState<boolean>(false);
  const [loggedUser, setLoggedUser] = useState<FullUserDTO>();
  const [billingData, setBillingData] = useState<Billing>();
  const [token, setToken] = useState<string | undefined>(cookie);
  const [newNotifications, setNewNotifications] = useState<
    number | undefined
  >();

  return (
    <AuthContext.Provider
      value={{
        loggedUser,
        token,
        setLoggedUser,
        setToken,
        newNotifications,
        setNewNotifications,
        billingData,
        setBillingData,
        setIsBillingDataReady,
        isBillingDataReady,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
